var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    _vm._l(_vm.options, function (option, index) {
      return _c(
        "v-flex",
        {
          key: index,
          staticClass: "app-checkbox",
          attrs: { "pt-0": "", "pb-0": "", "mt-0": "", "mb-0": "" },
        },
        [
          _c("v-checkbox", {
            attrs: {
              label: option[_vm.onText],
              value: option[_vm.onValue],
              color: _vm.color,
              row: _vm.row,
              error: _vm.hasError,
              disabled: option["disabled"] || _vm.disabled,
            },
            on: { change: _vm.change },
            model: {
              value: _vm.state,
              callback: function ($$v) {
                _vm.state = $$v
              },
              expression: "state",
            },
          }),
          _vm._v(" "),
          _vm.hasTooltip && option.tooltip.show
            ? _c(
                "v-tooltip",
                { attrs: { top: "" } },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        slot: "activator",
                        color: option.tooltip.color,
                        small: "",
                      },
                      slot: "activator",
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(option.tooltip.type) + "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(option.tooltip.text))]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }